import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const slideIn = keyframes`
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: ${fadeIn} 0.2s ease;
  padding: 20px;
`

const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  animation: ${slideIn} 0.3s ease;

  @media (max-width: 600px) {
    max-width: 100%;
    margin: 0 10px;
  }
`

const ModalHeader = styled.div<{ $type: 'info' | 'error' | 'success' | 'warning' | 'confirm' }>`
  padding: 20px 24px;
  border-bottom: 1px solid #e1e5e9;
  background: ${props => {
    switch (props.$type) {
      case 'error':
        return '#fee'
      case 'success':
        return '#efe'
      case 'warning':
        return '#fff3cd'
      case 'confirm':
        return '#e3f2fd'
      default:
        return '#f6f8fa'
    }
  }};
`

const ModalTitle = styled.h3<{ $type: 'info' | 'error' | 'success' | 'warning' | 'confirm' }>`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${props => {
    switch (props.$type) {
      case 'error':
        return '#dc3545'
      case 'success':
        return '#28a745'
      case 'warning':
        return '#856404'
      case 'confirm':
        return '#0066cc'
      default:
        return '#24292f'
    }
  }};
  display: flex;
  align-items: center;
  gap: 10px;
`

const ModalIcon = styled.span`
  font-size: 24px;
  line-height: 1;
`

const ModalBody = styled.div`
  padding: 24px;
  color: #333;
  font-size: 15px;
  line-height: 1.6;
  max-height: 60vh;
  overflow-y: auto;
`

const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #e1e5e9;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: #f6f8fa;
`

const Button = styled.button<{ $variant?: 'primary' | 'secondary' | 'danger' }>`
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid;
  transition: all 0.2s ease;

  ${props => {
    switch (props.$variant) {
      case 'primary':
        return `
          background: #0066cc;
          color: white;
          border-color: #0066cc;

          &:hover {
            background: #0052a3;
            border-color: #0052a3;
          }
        `
      case 'danger':
        return `
          background: #dc3545;
          color: white;
          border-color: #dc3545;

          &:hover {
            background: #c82333;
            border-color: #c82333;
          }
        `
      default:
        return `
          background: white;
          color: #333;
          border-color: #d0d7de;

          &:hover {
            background: #f6f8fa;
          }
        `
    }
  }}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export {
  Overlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  ModalIcon,
  ModalBody,
  ModalFooter,
  Button,
}